import React, { useState } from 'react';
import isPlainObject from 'lodash/isPlainObject';
import isArray from 'lodash/isArray';
const { CodeControl } = window?.VisualEngineUtils || {};
const { Button, CnBalloon, CnMessage } = window.CNUI || {};
export function JsonEditor(props) {
    const [visible, setVisible] = useState(false);
    const [code, setCode] = useState('');
    const { value, onChange } = props;
    const edit = () => {
        if (value) {
            if (isPlainObject(value) || isArray(value)) {
                try {
                    setCode(JSON.stringify(value, null, '\t'));
                }
                catch (e) { }
                setVisible(true);
            }
        }
    };
    const onOk = () => {
        try {
            const result = JSON.parse(code);
            if (result) {
                onChange?.(result);
                setCode('');
                setVisible(false);
            }
        }
        catch (e) {
            CnMessage.error('数据不符合JSON格式');
        }
    };
    return (React.createElement("div", { className: '' },
        React.createElement(CnBalloon
        // type={'primary'}
        , { 
            // type={'primary'}
            visible: visible, align: 'tr', v2: true, onVisibleChange: (v) => {
                setVisible(v);
            }, closable: true, triggerType: 'click', title: 'JSON编辑器', trigger: React.createElement(Button, { size: 'small', style: { width: '160px' }, onClick: edit }, "JSON\u7F16\u8F91\u5668") },
            React.createElement(CodeControl, { value: code, options: { minimap: { enabled: false }, lineNumbers: 'off' }, className: '', mode: 'json' // 'javascript', 'json', 'html', 'css', 'jsx'
                , fontSize: 14, tabSize: 2, 
                // readOnly={false}
                style: { width: '260px', height: 200 }, onChange: (code) => {
                    setCode(code);
                }, 
                // // 如果为 false 或者 0 则不启动节流阀
                throttle: 600, lineNumbers: 'off', enableOutline: false }),
            React.createElement("div", { style: {
                    paddingTop: '10px',
                    borderTop: '1px solid #ddd',
                    display: 'flex',
                    justifyContent: 'flex-end',
                } },
                React.createElement(Button, { onClick: () => {
                        setCode('');
                        setVisible(false);
                    }, size: 'small' }, "\u53D6\u6D88"),
                "\u00A0\u00A0",
                React.createElement(Button, { onClick: onOk, size: 'small', type: 'secondary' }, "\u786E\u5B9A")))));
}
